import React, { useContext } from "react";
import styled from "styled-components";
import { ExternalLink } from "components/common";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { SectionTitle, SectionNote } from "integrations/aws/common/sharedStyles";
import useProductName from "brand-customization/useProductName";
const INPUT_PATTERN = "https://(.*)";
const INPUT_MESSAGE = "Domain should begin with 'https://'";
const INPUT_PLACEHOLDER = "https://vpce-1234.service.region.vpce.amazonaws.com";
const StyledSectionTitle = styled(SectionTitle)`
  margin: 12px 0 0;
`;
const StyledSectionNote = styled(SectionNote)`
  margin: 0 0 12px;
`;
const AWSCustomEndpoints = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const productName = useProductName();
  const { isAWSCustomEndpointsVisible, setAWSCustomEndpointsVisibility } = useContext(AdvancedOptionsContext);
  const { awsEndpointCloudWatch, awsEndpointDynamoDB, awsEndpointIAM, awsEndpointKinesis } = formData;
  const handleToggle = (visible) => {
    setAWSCustomEndpointsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Optional AWS VPC Endpoints", visible: isAWSCustomEndpointsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(StyledSectionTitle, null, "Overrides the default AWS API endpoint URL that ", productName, " communicates with."), /* @__PURE__ */ React.createElement(StyledSectionNote, null, "Only specify these if you are using", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-endpoints.html" }, "VPC Endpoints"), " ", "for AWS services."), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "awsEndpointCloudWatch",
      type: "text",
      fieldData: awsEndpointCloudWatch,
      onChange,
      label: "CloudWatch API Endpoint Override",
      placeholder: INPUT_PLACEHOLDER,
      pattern: INPUT_PATTERN,
      title: INPUT_MESSAGE
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "awsEndpointIAM",
      type: "text",
      fieldData: awsEndpointIAM,
      onChange,
      label: "IAM API Endpoint Override",
      placeholder: INPUT_PLACEHOLDER,
      pattern: INPUT_PATTERN,
      title: INPUT_MESSAGE
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "awsEndpointDynamoDB",
      type: "text",
      fieldData: awsEndpointDynamoDB,
      onChange,
      label: "DynamoDB API Endpoint Override",
      placeholder: INPUT_PLACEHOLDER,
      pattern: INPUT_PATTERN,
      title: INPUT_MESSAGE
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "awsEndpointKinesis",
      type: "text",
      fieldData: awsEndpointKinesis,
      onChange,
      label: "Kinesis API Endpoint Override",
      placeholder: INPUT_PLACEHOLDER,
      pattern: INPUT_PATTERN,
      title: INPUT_MESSAGE
    }
  ));
};
export default AWSCustomEndpoints;
